module.exports = __webpack_public_path__ + "img/vccl.37ccbed9.svg";